import { render, staticRenderFns } from "./aiShare.vue?vue&type=template&id=327d26be&scoped=true"
import script from "./aiShare.vue?vue&type=script&lang=js"
export * from "./aiShare.vue?vue&type=script&lang=js"
import style0 from "./aiShare.vue?vue&type=style&index=0&id=327d26be&prod&lang=scss&scoped=true"
import style1 from "./aiShare.vue?vue&type=style&index=1&id=327d26be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d26be",
  null
  
)

export default component.exports